import React, { useCallback, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTable } from 'react-table'
import lodash from 'lodash'

// Styles
import Styles from './table.module.scss'

const Table = ({ data = [], status, COLLUMNS = [], fetchNextPage, hasNextPage, isFetchingNextPage }) => {
  const navigate = useNavigate();

  const memoizedColumns = React.useMemo(() => COLLUMNS, [COLLUMNS])
  const memoizedData = React.useMemo(() => data, [data])

  const tableInstance = useTable({ columns: memoizedColumns, data: memoizedData })

  const handleWaktuPembayaran = (remainingDays) => {
    if (!remainingDays) return "";
    if (typeof remainingDays === "number") return `${remainingDays}`;

    return `${remainingDays.replaceAll("+-", "")}`;
  }

  const TotalSaldoAkhir = React.useMemo(() => {
    if (!data?.length) return 0

    const total = lodash.sumBy(data, (item) => {
      return item.fullData.total_amount
    })

    return lodash.toNumber(total)
  }, [data])

  const {
    getTableProps,
    headerGroups,
    rows,
    prepareRow
  } = tableInstance

  // Create an observer for infinite scrolling with improved options
  const observer = useRef()
  const lastInvoiceElementRef = useCallback(
    (node) => {
      if (isFetchingNextPage || !hasNextPage) return
      if (observer.current) observer.current.disconnect()
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasNextPage) {
          fetchNextPage()
        }
      })
      if (node) observer.current.observe(node)
    },
    [isFetchingNextPage, hasNextPage, fetchNextPage]
  )

  return (
    <table {...getTableProps()} className={Styles['table']}>
      <thead className={Styles['table-head']}>
        {
          headerGroups.map((headerGroup, key) => (
            <tr key={`table-invoice-header-${key}`} {...headerGroup.getHeaderGroupProps()} className={Styles['table-row']}>
              {
                headerGroup.headers.map((column, i) => (
                  <th {...column.getHeaderProps()} className={`${Styles['table-head-cell']} `}>
                    <div className={Styles['content']}>
                      <span>
                        {column.render('Header')}
                      </span>
                    </div>
                  </th>
                ))
              }
            </tr>
          ))
        }
      </thead>

      <tbody {...tableInstance.getTableBodyProps()} className={Styles['table-body']}>
        {rows.map((row, key) => {
          prepareRow(row)
          return (
            <tr
              key={`table-invoice-body-${key}`}
              {...row.getRowProps()}
              className={Styles['table-row']}
              ref={row.original?.isLastElement ? lastInvoiceElementRef : null}
            >
              {row.cells.map((cell, i) => (
                <td {...cell.getCellProps()} className={`${Styles['table-body-cell']} `}>
                  <div className={Styles['content']}>
                    {
                      (i === 1) ? (
                        <button onClick={() => navigate(`/invoice/${cell.row.original.invoice_id}?company_id=${cell.row.original.fullData.company_id}&month=${cell.row.original.fullData.month}&year=${cell.row.original.fullData.year}`)} className={Styles['invoice_number']}>
                          <span>
                            {cell.render('Cell')}
                          </span>
                        </button>
                      ) : (i === 4 && status === "menunggu") ? (
                        <div className={Styles['jatuh-tempo']}>
                          <span className={`${Styles['label']} ${(typeof row.original.remaining_days === "string") ? "" : "invisible"}`}>
                            Lewat {handleWaktuPembayaran(row.original.remaining_days)} hari
                          </span>
                          <span>
                            {cell.render('Cell')}
                          </span>
                        </div>
                      ) : (
                        <span>
                          {cell.render('Cell')}
                        </span>
                      )
                    }
                  </div>
                </td>
              ))}
            </tr>
          )
        })}
      </tbody>

      {isFetchingNextPage && (
        <tfoot>
          <tr>
            <td colSpan={COLLUMNS.length} style={{ textAlign: 'center', padding: '10px' }}>
              Memuat data...
            </td>
          </tr>
        </tfoot>
      )}

      {/* Debug button to manually trigger fetchNextPage */}
      {hasNextPage && (
        <tfoot>
          <tr>
            <td colSpan={COLLUMNS.length} style={{ textAlign: 'center', padding: '10px' }}>
              <button
                onClick={() => {
                  fetchNextPage();
                }}
                style={{ padding: '5px 10px', background: '#f0f0f0', border: '1px solid #ccc' }}
              >
                Load More (Debug)
              </button>
            </td>
          </tr>
        </tfoot>
      )}

      {status === "menunggu" && <tfoot className={Styles['table-foot']}>
        <tr>
          <td colSpan={1}></td>
          <td colSpan={1}>Total Saldo Akhir</td>
          <td colSpan={2}>{TotalSaldoAkhir.toLocaleString("id-ID")}</td>
          <td colSpan={2}></td>
        </tr>
      </tfoot>}
    </table>
  )
}

export default Table